//
import Model from "@/models/Model"
import AAvailableBranchOfficesModel from "@/models/Actions/AAvailableBranchOffices"
import AChangeBranchOfficeModel from "@/models/Actions/AChangeBranchOffice"

/**
 * 
 */
export default class HrEmployee extends Model {

    static includes = [
        'hr_employee_available_g_branch_offices',
    ]

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    available_branch_offices() {
        return this.hasMany(AAvailableBranchOfficesModel)
    }

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    change_branch_office() {
        return this.hasMany(AChangeBranchOfficeModel)
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get full_name() {
        return [
            String( this.names ),
            String( this.last_name1 ),
            String( this.last_name2 ),
        ].join( " " )
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get g_branch_office_name() {
        return this.getProperty('g_branch_office.name', '-')
    }

    /**
     * 
     */
    resource () {
        return "hr_employee"
    }

    /**
     * Returns a change branch office representation of the object.
     *
     * @return     {<type>}  Change branch office representation of the object.
     */
    toChangeBranchOffice() {
        return this.clean([
            'g_branch_office_id'
        ])
    }
}